var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizeout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.59 20.48C7.91 20.48 8.17 20.22 8.17 19.9C8.17 19.58 7.91 19.32 7.59 19.32C7.44 19.32 6.73 19.32 5.44 19.32C7.34 17.42 8.4 16.36 8.61 16.15C8.84 15.92 8.84 15.55 8.61 15.32C8.5 15.21 8.35 15.15 8.2 15.15C8.05 15.15 7.9 15.21 7.79 15.32C7.58 15.53 6.54 16.57 4.68 18.43C4.68 17.22 4.68 16.55 4.68 16.41C4.68 16.09 4.42 15.83 4.1 15.83C3.78 15.83 3.52 16.09 3.52 16.41C3.52 16.76 3.52 19.55 3.52 19.9C3.52 20.22 3.78 20.48 4.1 20.48C4.8 20.48 7.24 20.48 7.59 20.48Z",
    id: "bPkupCi1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.41 19.29C16.09 19.29 15.83 19.55 15.83 19.87C15.83 20.19 16.09 20.45 16.41 20.45C16.76 20.45 19.55 20.45 19.9 20.45C20.22 20.45 20.48 20.19 20.48 19.87C20.48 19.52 20.48 16.73 20.48 16.38C20.48 16.06 20.22 15.8 19.9 15.8C19.58 15.8 19.32 16.06 19.32 16.38C19.32 16.52 19.32 17.24 19.32 18.53C17.42 16.63 16.36 15.57 16.15 15.36C16.03 15.24 15.88 15.19 15.74 15.19C15.59 15.19 15.44 15.24 15.32 15.36C15.1 15.58 15.1 15.95 15.32 16.18C15.53 16.39 16.57 17.42 18.43 19.29C17.22 19.29 16.55 19.29 16.41 19.29Z",
    id: "i3dzYtMPi8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 5.55C19.32 6.76 19.32 7.43 19.32 7.57C19.32 7.89 19.58 8.15 19.9 8.15C20.22 8.15 20.48 7.89 20.48 7.57C20.48 7.22 20.48 4.42 20.48 4.08C20.48 3.75 20.22 3.49 19.9 3.49C19.55 3.49 16.76 3.49 16.41 3.49C16.09 3.49 15.83 3.75 15.83 4.08C15.83 4.4 16.09 4.66 16.41 4.66C16.56 4.66 17.27 4.66 18.56 4.66C16.66 6.56 15.6 7.62 15.39 7.83C15.16 8.06 15.16 8.43 15.39 8.65C15.62 8.88 15.99 8.88 16.21 8.65C16.63 8.24 17.66 7.2 19.32 5.55Z",
    id: "d9RzmX5clK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68 7.6C4.68 7.45 4.68 6.74 4.68 5.45C6.58 7.35 7.64 8.41 7.85 8.62C8.08 8.85 8.45 8.85 8.68 8.62C8.9 8.39 8.9 8.02 8.68 7.8C8.47 7.59 7.43 6.55 5.57 4.69C6.78 4.69 7.45 4.69 7.59 4.69C7.91 4.69 8.17 4.43 8.17 4.11C8.17 3.79 7.91 3.53 7.59 3.53C7.24 3.53 4.45 3.53 4.1 3.53C3.78 3.53 3.52 3.79 3.52 4.11C3.52 4.46 3.52 7.25 3.52 7.6C3.52 7.92 3.78 8.18 4.1 8.18C4.42 8.18 4.68 7.92 4.68 7.6Z",
    id: "a3IP2jWR9N"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93 0C1.31 0 0 1.31 0 2.93C0 4.74 0 19.26 0 21.07C0 22.69 1.31 24 2.93 24C4.74 24 19.26 24 21.07 24C22.69 24 24 22.69 24 21.07C24 19.26 24 4.74 24 2.93C24 1.31 22.69 0 21.07 0C17.44 0 4.74 0 2.93 0ZM21.07 22.84C19.26 22.84 4.74 22.84 2.93 22.84C1.96 22.84 1.16 22.04 1.16 21.07C1.16 19.26 1.16 4.74 1.16 2.93C1.16 1.96 1.96 1.16 2.93 1.16C4.74 1.16 19.26 1.16 21.07 1.16C22.04 1.16 22.84 1.96 22.84 2.93C22.84 4.14 22.84 10.19 22.84 21.07C22.31 22.25 21.72 22.84 21.07 22.84Z",
    id: "d28suV5S4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bPkupCi1A",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bPkupCi1A",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i3dzYtMPi8",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i3dzYtMPi8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d9RzmX5clK",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d9RzmX5clK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3IP2jWR9N",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3IP2jWR9N",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d28suV5S4",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d28suV5S4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeout);
export default __webpack_public_path__ + "static/media/resizeout.7dfa13de0ede03b3ff955e8d2a23c128.svg";
export { ForwardRef as ReactComponent };